//#region IMPORT
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import M_TBM_BASIC_04 from './M_TBM_BASIC_04';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import 'pdfjs-dist/build/pdf.worker.entry';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_BASIC_04F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보

  const [fullUrl, setFullUrl] = useState();
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfFile, setPdfFile] = useState();
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1); // 100% 화면 너비로 시작
  const [pageViewHeight, setPageViewHeight] = useState(0); // 페이지 렌더링 높이 상태 추가
  const [renderPreview, setRenderPreview] = useState([]);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  // 스택형 뒤로가기로 변경: 확인 모달이 열린 동안 뒤로가기를 막음
  useBackStack({
    type: 'block',
    enabled: props.modalToggle2 === true,
    onBack: () => {},
  });

  useEffect(() => {
    Init();
    const handleResize = () => {
      setPageWidth(window.innerWidth * 1); // 화면 크기 바뀔 때 다시 계산
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pdfFile) {
      const full = Global.file.useUrl + 'files/' + pdfFile;
      setFullUrl(full);
    }
  }, [pdfFile]);

  const Init = async () => {
    setLoading(true);

    try {
      await SearchLogic2();
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleExcelUpload = async (file) => {
  //   const data = await file.arrayBuffer();
  //   const workbook = XLSX.read(data);
  //   const sheetName = workbook.SheetNames[0];
  //   const worksheet = workbook.Sheets[sheetName];
  //   const html = XLSX.utils.sheet_to_html(worksheet);
  //   document.getElementById('preview').innerHTML = html;
  // };

  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const SearchLogic2 = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R5',
            _CUST_CD: Commons.EncryptAES(userInfo.custCd),
            _DEP_CD: Commons.EncryptAES(userInfo.depCd),
          },
        ]
      ).then((result) => {
        let data = result.data;

        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          const path = data[0].FILE_PATH;
          const full = Global.file.useUrl + 'files/' + path;

          setPdfFile(path);
          setFullUrl(full);

          // PDF, 한글파일만 작업계획서 업로드 가능!!!
          // PDF 이미지 미리보기 생성
          if (getExtensionFromUrl(path) === 'pdf') {
            generatePdfPreview(full);
          }
          // if (getExtensionFromUrl(path) === 'pptx') {
          //   generatePptPreview(full);
          // }
          if (
            getExtensionFromUrl(path) === 'hwp' ||
            getExtensionFromUrl(path) === 'hwpx'
          ) {
            generateHwpPreview(full);
          }
        }
      });
    } catch (e) {
      console.log(e);
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  // 미리보기 렌더 함수 (previewUrl 기반)
  //#region
  // PDF 미리보기
  const generatePdfPreview = async (url) => {
    // const pdfjsLib = await import('pdfjs-dist/build/pdf');
    // pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

    // const loadingTask = pdfjsLib.getDocument(url);
    // const pdf = await loadingTask.promise;
    // const totalPages = pdf.numPages;

    // setNumPages(totalPages);
    // const imageUrls = [];

    // for (let i = 1; i <= totalPages; i++) {
    //   const page = await pdf.getPage(i);
    //   const viewport = page.getViewport({ scale: 1.5 });
    //   const canvas = document.createElement('canvas');
    //   const context = canvas.getContext('2d');
    //   canvas.height = viewport.height;
    //   canvas.width = viewport.width;

    //   await page.render({ canvasContext: context, viewport }).promise;
    //   imageUrls.push(canvas.toDataURL());
    // }

    // setRenderPreview(imageUrls);

    // 원본 PDF 파일을 fetch
    const response = await fetch(url);
    const blob = await response.blob();

    // PDF 전체를 가리키는 blob URL 생성
    const blobUrl = URL.createObjectURL(blob);

    // 상태에 저장해서 뷰어에 사용
    setRenderPreview(blobUrl);
  };
  // PPT 미리보기
  // const generatePptPreview = async (url) => {
  //   const relativePath = extractRelativeFilePath(url);

  //   console.log('파일추출', url);
  //   if (!relativePath) {
  //     console.error('파일 경로 추출 실패');
  //     return;
  //   }

  //   const convertedUrl = await handlePptPreview(relativePath); // 상대경로로 호출

  //   console.log('url', url);
  //   console.log('convertedUrl', convertedUrl);
  //   if (convertedUrl) {
  //     const pdfUrl = Global.file.useUrl + convertedUrl;
  //     const blob = await fetch(pdfUrl).then((res) => res.blob());
  //     await renderPdfToImages(blob); // PDF → 이미지 변환 함수 재사용
  //   }
  // };
  // HWP 미리보기
  const generateHwpPreview = async (url) => {
    // 원본 PDF 파일을 fetch
    const response = await fetch(url.replace(/\.hwp$/i, '.pdf'));
    const blob = await response.blob();

    // PDF 전체를 가리키는 blob URL 생성
    const blobUrl = URL.createObjectURL(blob);

    // 상태에 저장해서 뷰어에 사용
    setRenderPreview(blobUrl);
  };
  // const extractRelativeFilePath = (fullUrl) => {
  //   // "https://devsafetylv.com/files/" 이후의 경로만 추출
  //   const marker = '/M_Files/';
  //   const index = fullUrl.indexOf(marker);
  //   if (index === -1) return null;

  //   return fullUrl.substring(index + marker.length);
  // };
  //#endregion

  // PPT → PDF 변환
  // const ConvertPptToPdf = async (_filePath) => {
  //   if (!_filePath) {
  //     console.error('ConvertPptToPdf: filePath가 없습니다.');
  //     return null;
  //   }

  //   console.log('PPT → PDF 변환', _filePath);

  //   try {
  //     const payload = { FilePath: _filePath };

  //     const response = await Commons.Axios(
  //       'file2', // HWP 변환과 동일하게 처리
  //       Global.file.useUrl + Global.urls.Execute.videoUpload, // 🔁 여기가 PPT용 API 경로
  //       null,
  //       payload
  //     );

  //     console.log('response', response);

  //     if (response?.data?.url) {
  //       return response.data.url; // 예: "/PreviewFiles/example.pdf"
  //     } else {
  //       console.error('ConvertPptToPdf: 서버 응답이 유효하지 않음', response);
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error('ConvertPptToPdf: 요청 중 오류 발생', error);
  //     return null;
  //   }
  // };

  // const handlePptPreview = async (_filePath) => {
  //   console.log('핸들프리뷰', _filePath);
  //   const convertedUrl = await ConvertPptToPdf(_filePath);
  //   if (convertedUrl) {
  //     const fullUrl = Global.file.useUrl + convertedUrl;
  //     const blob = await fetch(fullUrl).then((res) => res.blob());
  //     await renderPdfToImages(blob); // PDF → 이미지 변환 함수 재사용
  //   }
  //   return convertedUrl; // ✅ 추가: 변환된 URL 반환
  // };

  // PDF → 이미지 변환 함수
  // const renderPdfToImages = async (pdfBlob) => {
  //   console.log('pdfBlob', pdfBlob);
  //   const pdf = await pdfjsLib.getDocument({ data: pdfBlob }).promise;
  //   const images = [];

  //   for (let i = 1; i <= pdf.numPages; i++) {
  //     const page = await pdf.getPage(i);
  //     const viewport = page.getViewport({ scale: 1.5 });
  //     const canvas = document.createElement('canvas');
  //     const context = canvas.getContext('2d');

  //     canvas.height = viewport.height;
  //     canvas.width = viewport.width;

  //     await page.render({ canvasContext: context, viewport }).promise;
  //     images.push(canvas.toDataURL('image/png'));
  //   }

  //   setPdfImages(images);
  //   console.log('변환된 이미지', images);
  // };

  //#region 나머지 함수
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    } else {
      dispatch(CommonActions.setActiveStep(activeStep - 1));
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };
  //#endregion
  return (
    <M_TBM_BASIC_04
      userInfo={userInfo}
      pdfFile={pdfFile}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      check={props.check}
      setCheck={props.setCheck}
      pdfImages={pdfImages}
      setPdfImages={setPdfImages}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      // 함수
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      ActiveButton={props.ActiveButton}
      getExtensionFromUrl={getExtensionFromUrl}
      renderPreview={renderPreview}
      fullUrl={fullUrl}
    />
  );
}

export default M_TBM_BASIC_04F;
